$(document).on('click','[data-url-when-clicked]', function(){
    try {
        mixpanel.track('Search - Click car', {'sourceRouteName': 'wlz_car_search_by_location'});
    } catch(e) {
        console.error(e);
    }

    setTimeout(
        (function(href) {
            return function () {
                document.location = href;
            }
        })($(this).data('url-when-clicked'))
        , 300
    );
});
